<script lang="ts">
  export let numbers: number[];
  export let big: boolean = false;
</script>

<div class="container {big ? 'big' : ''}">
  <button on:click class="btn ">
    {#each numbers as num}
      <div class="num">{num}</div>
    {/each}
  </button>
</div>

<style>
  .container {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .big {
    font-size: 36px;
    height: 240px;
  }
  .btn {
    display: grid;
    width: 4em;
    font-weight: 700;
    transition: transform 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
    grid-template-columns: auto auto auto auto;
    font-family: monospace;
    padding: 0.3em;

    background: none;
    margin: 0px;
    border: none;
    text-align: center;
  }

  .btn:hover {
    transform: translateY(-2px);
    cursor: pointer;
  }

  .btn:hover,
  .btn:focus {
    box-shadow: 1px 0px 5px 0px rgba(0, 0, 0, 0.45);
  }

  .num {
    text-align: center;
  }
</style>
